// src/api/utils/apiHandler.ts

/**
 * Construct a Request object with proper HTTP semantics
 *
 * @param url - API endpoint URL
 * @param method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param access_token - Bearer token for authentication
 * @param form_data - FormData for request body (optional, not used for GET/HEAD/DELETE)
 * @param abort_signal - AbortSignal for request cancellation
 * @returns Request object ready for fetch()
 */
export function constructRequest(
  url: string,
  method: string,
  access_token: string | null,
  form_data?: FormData,
  abort_signal?: AbortSignal
): Request {
  const headers: HeadersInit = {};
  if (access_token) {
    headers.Authorization = `Bearer ${access_token}`;
  }

  // Security header for AWS WAF validation
  if (process.env.X_INTERNAL_TOKEN) {
    headers["X-Internal-Token"] = process.env.X_INTERNAL_TOKEN;
  }

  // HTTP semantics: GET, HEAD, and DELETE should not have a body
  const methodUpperCase = method.toUpperCase();
  const shouldHaveBody =
    methodUpperCase !== "GET" && methodUpperCase !== "HEAD" && methodUpperCase !== "DELETE";

  const request = new Request(url, {
    method,
    headers,
    body: shouldHaveBody ? form_data : undefined,
    signal: abort_signal,
  });

  return request;
}
